import { Grid, Typography } from "@mui/material";
import { Controller, useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";
import CustomAutocompleteMulti from "../../../common/components/functional/customAutocomplete/CustomAutocompleteMulti";
import FormSection from "../../../common/components/functional/formSection/FormSection";
import TitleOptional from "../../../common/components/functional/titleOptional/TitleOptional";
import { AutocompleteType } from "../../../common/types/autoComplete";
import { useEffect } from "react";

type Props = {
  skillOptions: AutocompleteType[];
};

const Skills = ({ skillOptions }: Props) => {
  const { t } = useTranslation();
  const { control, setValue, watch, formState } = useFormContext();

  const workTitle = watch("workTitle");

  useEffect(() => {
    if (workTitle?.id && formState.dirtyFields["workTitle"]) {
      setValue("skills", []);
    }
  }, [workTitle?.id, setValue, formState.dirtyFields]);

  return (
    <FormSection title={<TitleOptional title={t("common:requiredSkills")} />}>
      <Grid container item xs={3} justifyContent="flex-end" alignItems="center">
        <Typography color="textSecondary" textAlign="end">
          {t("common:skills")}
        </Typography>
      </Grid>
      <Grid item xs={9}>
        <Controller
          control={control}
          name="skills"
          render={({ field: { value, onChange } }) => (
            <CustomAutocompleteMulti
              name="skills"
              defaultValue={value || []}
              options={skillOptions}
              onChange={(_: any, newValue: AutocompleteType[]) =>
                onChange(newValue)
              }
            />
          )}
        />
      </Grid>
    </FormSection>
  );
};

export default Skills;
